import { useState } from "react"
import styled from "styled-components"

import { FAQ_ITEMS } from "./content"
import { mobileBreakpoint, textDark, textGrey } from "./shared"

const FaqSection = styled.section`
  max-width: 1180px;
  margin: 0 auto;
  padding: 80px 24px;
  /* breathing room above the title when reached via the header anchor links */
  scroll-margin-top: 48px;

  h2 {
    font-size: 1.375rem;
    font-weight: 500;
  }
`

const FaqGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 48px;
  margin-top: 24px;

  @media only screen and (width <= ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
  }
`

const FaqItem = styled.div`
  border-bottom: 1px solid #e2e8f0;

  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 18px 0;
    border: none;
    background: none;
    color: ${textDark};
    cursor: pointer;
    font-family: inherit;
    font-size: 0.8125rem;
    font-weight: 500;
    text-align: left;

    span {
      color: ${textGrey};
      font-size: 1rem;
      font-weight: 400;
    }
  }

  p {
    margin: 0;
    padding: 0 0 18px;
    color: ${textGrey};
    font-size: 0.8125rem;
    line-height: 1.6;
  }
`

export const Faq = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  return (
    <FaqSection id="faq">
      <h2>Questions? We&apos;ve got you.</h2>
      <FaqGrid>
        {FAQ_ITEMS.map((item, index) => (
          <FaqItem key={item.question}>
            <button type="button" onClick={() => setOpenFaq(openFaq === index ? null : index)}>
              {item.question}
              <span aria-hidden>{openFaq === index ? "−" : "+"}</span>
            </button>
            {openFaq === index && <p>{item.answer}</p>}
          </FaqItem>
        ))}
      </FaqGrid>
    </FaqSection>
  )
}
